import Layout from '@/layout/Layout.vue'

/**
 * 静态路由
 */
const staticRoutes = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/', redirect: '/dashboard' }
]

/**
 * 动态路由映射（根据permissionCode匹配）
 */
const routeMap = {
  'system': { path: '/system', component: Layout, name: '系统管理', meta: { title: '系统管理', icon: 'el-icon-setting' } },
  'system:user': { path: 'user', component: () => import('@/views/system/user/index'), name: '用户管理', meta: { title: '用户管理' } },
  'system:role': { path: 'role', component: () => import('@/views/system/role/index'), name: '角色管理', meta: { title: '角色管理' } },
  'system:permission': { path: 'permission', component: () => import('@/views/system/permission/index'), name: '权限管理', meta: { title: '权限管理' } },
  'admission': { path: '/admission', component: Layout, name: '招生管理', meta: { title: '招生管理', icon: 'el-icon-document' } },
  'admission:school': { path: 'school', component: () => import('@/views/admission/school/index'), name: '学校信息', meta: { title: '学校信息' } },
  'admission:college': { path: 'college', component: () => import('@/views/admission/college/index'), name: '院系管理', meta: { title: '院系管理' } },
  'admission:major': { path: 'major', component: () => import('@/views/admission/major/index'), name: '专业介绍', meta: { title: '专业介绍' } },
  'admission:tutor': { path: 'tutor', component: () => import('@/views/admission/tutor/index'), name: '导师信息', meta: { title: '导师信息' } },
  'admission:plan': { path: 'plan', component: () => import('@/views/admission/plan/index'), name: '招生计划', meta: { title: '招生计划' } },
  'admission:score': { path: 'score', component: () => import('@/views/admission/score/index'), name: '分数管理', meta: { title: '分数管理' } },
  'admission:brochure': { path: 'brochure', component: () => import('@/views/admission/brochure/index'), name: '招生简章', meta: { title: '招生简章' } },
  'content': { path: '/content', component: Layout, name: '首页管理', meta: { title: '首页管理', icon: 'el-icon-document-copy' } },
  'content:news': { path: 'campus-news', component: () => import('@/views/content/campus-news/index'), name: '院校动态', meta: { title: '院校动态' } },
  'content:notice': { path: 'notice', component: () => import('@/views/content/notice/index'), name: '通知动态', meta: { title: '通知动态' } },
  'content:scenery': { path: 'scenery', component: () => import('@/views/content/scenery/index'), name: '院校风光', meta: { title: '院校风光' } },
  'content:campus': { path: 'campus', component: () => import('@/views/content/campus/index'), name: '院校', meta: { title: '院校' } },
  'profile': {
    path: '/profile',
    component: Layout,
    name: '个人中心',
    meta: { title: '个人中心', icon: 'el-icon-user' },
    children: [
      { path: 'index', component: () => import('@/views/profile/index'), name: '个人中心', meta: { title: '个人中心' } }
    ]
  }
}

const state = {
  routes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.routes = routes
  }
}

const actions = {
  generateRoutes({ commit }, permissions) {
    return new Promise(resolve => {
      const accessedRoutes = []

      // 首页（所有登录用户都可见）
      accessedRoutes.push({
        path: '/dashboard',
        component: Layout,
        children: [{
          path: '',
          component: () => import('@/views/dashboard/index'),
          name: '首页',
          meta: { title: '首页', icon: 'el-icon-s-home' }
        }]
      })

      // 识别所有顶级模块（不含冒号的权限码）
      const parentCodes = new Set()
      permissions.forEach(code => {
        const colonIndex = code.indexOf(':')
        if (colonIndex === -1) {
          parentCodes.add(code)
        } else {
          parentCodes.add(code.substring(0, colonIndex))
        }
      })

      // 为每个顶级模块构建路由树
      parentCodes.forEach(parentCode => {
        // 跳过profile，它会单独处理
        if (parentCode === 'profile') return

        const parentConfig = routeMap[parentCode]
        if (!parentConfig) return

        const parentRoute = {
          path: parentConfig.path,
          component: parentConfig.component,
          name: parentConfig.name,
          meta: parentConfig.meta,
          children: []
        }

        // 查找该模块下的子权限
        permissions.forEach(code => {
          if (code.startsWith(parentCode + ':')) {
            const childConfig = routeMap[code]
            if (childConfig) {
              parentRoute.children.push({
                path: childConfig.path,
                component: childConfig.component,
                name: childConfig.name,
                meta: childConfig.meta
              })
            }
          }
        })

        accessedRoutes.push(parentRoute)
      })

      // 个人中心路由（所有登录用户都可以访问）
      if (routeMap['profile']) {
        accessedRoutes.push({ ...routeMap['profile'] })
      }

      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
